'use client';

import { useEffect, useMemo } from 'react';
import { usePathname } from 'next/navigation';

import {
  DEFAULT_THEME,
  getStaticThemeForPath,
  getStatusPageSlugFromPath,
} from '@/lib/theme/theme-matchers';

import { useThemeController } from './theme-provider';

export function ThemeWatcher() {
  const pathname = usePathname();
  const { setTheme } = useThemeController();

  const resolvedPathname = useMemo(() => pathname || '/', [pathname]);

  useEffect(() => {
    const staticTheme = getStaticThemeForPath(resolvedPathname);
    if (staticTheme) {
      setTheme(staticTheme);
      return;
    }

    const statusSlug = getStatusPageSlugFromPath(resolvedPathname);
    if (statusSlug) {
      // Status pages supply their theme via a dedicated client bridge.
      return;
    }

    setTheme(DEFAULT_THEME);
  }, [resolvedPathname, setTheme]);

  return null;
}
